@switch (recordChangeType()) {
  @case ('salesperson-updated') {
    <crm-activity-record-change-salesperson-updated
      [activity]="activity()"
      [showPrimaryAssociation]="showPrimaryAssociation()"
    >
    </crm-activity-record-change-salesperson-updated>
  }
  @case ('opportunity-status-change') {
    <crm-activity-record-change-opportunity-status-change
      [activity]="activity()"
      [showPrimaryAssociation]="showPrimaryAssociation()"
    >
    </crm-activity-record-change-opportunity-status-change>
  }
  @default {
    <crm-activity-record-change-base [activity]="activity()" [showPrimaryAssociation]="showPrimaryAssociation()">
    </crm-activity-record-change-base>
  }
}
